export const requestLog: Record<string, string> = {
    title: 'Журнал инициативы № {number}',
    backToRequest: 'К инициативе',
};
